import styles from "./ManageBSM.module.css";
import config from "environment";
import dayjs from "dayjs";
import { useState, memo } from "react";
import { useTranslation } from "react-i18next";
import { IconBook, IconTraining } from "@wwg/icons";
import { Toggle } from "@wwg/ui";
import { useBSMs } from "./useBSMs";

export function ManageBSM() {
  const { t } = useTranslation();
  const { isLoading, isError, error, audios, books, returnBSMMutation } =
    useBSMs();

  if (isLoading) {
    return "LOADING";
  }

  if (isError) {
    console.error(error);
    return "ERROR";
  }

  return (
    <div className={styles.container}>
      {audios.length > 0 && (
        <Section
          title={t("labels.bsmAudiosHeader")}
          icon={<IconTraining size={32} />}
          items={audios}
          returnBSMMutation={returnBSMMutation}
        />
      )}

      {books.length > 0 && (
        <Section
          title={t("labels.bsmBooksHeader")}
          icon={<IconBook size={32} />}
          items={books}
          returnBSMMutation={returnBSMMutation}
        />
      )}

      {audios.length === 0 && books.length === 0 && (
        <span className={styles.emptyLabel}>
          {t("labels.prospectBSMsCheckedOutEmptyLabel")}
        </span>
      )}
    </div>
  );
}

const Section = memo(({ title, icon, items, returnBSMMutation }) => {
  const { t } = useTranslation();

  return (
    <section className={styles.section}>
      <header>
        <h2>{title}</h2>
        <div className={styles.icon}>{icon}</div>
      </header>

      <ul className={styles.itemsList}>
        {items.map((item) => {
          return (
            <li key={item.handoutId}>
              <div className={styles.itemDetails}>
                <span className={styles.detailsName}>{item.contactName}</span>
                <span className={styles.detailsHandout}>
                  {item.handoutName}
                </span>
                <span className={styles.detailsDate}>
                  {dayjs(item.createdOn).format(config.dateTimeFormat)}
                </span>
              </div>
              <div className={styles.itemToggle}>
                <label
                  className={styles.toggleLabel}
                  htmlFor={`${item.handoutId}-returned`}
                >
                  {t("labels.prospectBSMReturned")}
                </label>
                <ItemToggle
                  id={`${item.handoutId}-returned`}
                  onChange={() => {
                    returnBSMMutation.mutate({
                      contactId: item.contactId,
                      handoutId: item.handoutId,
                    });
                  }}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
});

function ItemToggle({ ...props }) {
  const [isOn, setIsOn] = useState(false);

  return (
    <Toggle
      {...props}
      isOn={isOn}
      onChange={(value) => {
        setIsOn(true);
        props.onChange(value);
      }}
    />
  );
}
